<template>
  <div class="reportListData">
    <div class="item" v-for="(item,index) in listData" :key="index">
      <div class="item_label">
        <span>{{item.exam_class}}</span>
        <span class="status Success">
          <span class="status Info" v-if="item.report_status==9">已完成</span>
          <span class="status Danger" v-else>未完成</span>
        </span>
      </div>
      <div class="item_content">
        <div>
          <span class="label">申请单号:</span>
          <span class="content">{{item.odd_number}}</span>
        </div>
        <div>
          <span class="label">患者姓名:</span>
          <span class="content">{{item.name}}</span>
        </div>
        <div>
          <span class="label">发起医院:</span>
          <span class="content">{{item.local_institution_name}}</span>
        </div>
        <div>
          <span class="label">接收医院:</span>
          <span class="content">{{item.remote_institution_name}}</span>
        </div>
        <div>
          <span class="label">订单金额:</span>
          <span class="content">{{formatMoney(item.order_money)}}</span>
        </div>
        <div>
          <span class="label">申请日期:</span>
          <span class="content">{{formatDate(item.req_date_time)}}</span>
        </div>
      </div>
      <div class="item_time">
        <span>
          <button class="payButton" v-if="(item.report_status == 3 && item.status == 1 )" @click="pay(item)">立即支付</button>
        </span>
        <span>
          <!-- <button class="checkButton" v-if="item.report_status == 9" @click="checkReport(item)">查看报告</button> -->
          <button class="checkButton" @click="checkReport(item)">查看</button>
        </span>
        <span>
          <!-- <button
            class="checkButton"
            v-if="item.report_status == 9"
            @click="callReportPrint(item)"
          >报告原件</button>-->
          <!-- <button class="checkButton" @click="callReportPrint(item)">报告原件</button> -->
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Storage from '@/tools/storage'
export default {
  name: 'reportResult',
  props: ['listData'],
  data() {
    return {}
  },
  methods: {
    formatStatus(item) {
      if (item.report_status == 9) {
        this.className = 'status Info'
        return '已完成'
      } else {
        this.className = 'status Danger'
        return '未完成'
      }
    },
    // Danger
    // formatStatusColor(report_status) {
    //   if (report_status === 9) {
    //     return 'status Info'
    //   }
    //   if (report_status === 3) {
    //     return 'status Danger'
    //   }
    //   if (report_status != 3 && report_status != 9) {
    //     return 'status Danger'
    //   }
    // if (report_status === 3) {
    //   return 'status Danger'
    // } else if (report_status === 9) {
    //   return 'status Success'
    // } else {
    //   return 'status Danger'
    // }
    // if (status === 3) {
    //   return 'status Success'
    // }
    // if (status === 4) {
    //   return 'status Info'
    // }
    // if (status === 5) {
    //   return 'status Info'
    // }
    // },
    formatMoney(money) {
      if (!money) {
        return '免费'
      } else {
        return money / 100.0 + '元'
      }
    },
    formatDate(t) {
      let timer = t.replace(/\-/g, '/')
      // var timer = '2012-08-12 23:13'
      timer = timer.replace(/-/g, '/')
      const date = new Date(timer)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return (
        year +
        '年' +
        (month > 9 ? `${month}` : `0${month}`) +
        '月' +
        (day > 9 ? `${day}` : `0${day}`) +
        '日'
      )
    },
    checkReport(item) {
      // if (item.report_status != 9) {
      //   alert('远程报告未完成,无法查看报告')
      // }
      if (item.report_status == 3 && item.status == 1) {
        alert('未支付数字影像服务费,无法查看报告')
        return
      }
      if (item.report_status < 6 || item.report_status > 10) {
        alert('暂无影像')
        return
      }
      Storage.set('studyId', item.study_id)
      let params = { exam_id: item.exam_id }
      this.$emit('getReportInfo', params)
    },
    pay(item) {
      if (item.report_status == 3 && item.status == 1) {
        let params = { id: item.ra_id, openid: Storage.get('openid') }
        this.$emit('getWechatPay', params)
      }
    },
    callReportPrint(item) {
      this.$emit('callReportPrint', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.reportListData {
  width: 100%;
  display: inline-block;
  flex: 1;
  overflow-y: scroll;
  .item {
    height: 200px;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 20px;
    .item_label {
      height: 30px;
      border-bottom: 1px solid #cccccc;
      display: flex;
      align-items: center;
      color: #51cde4;
      justify-content: space-between;
      font-size: 16px;
      .status {
        font-size: 0.26667rem;
      }
      .Danger {
        color: #f56c6c;
      }
    }
    .item_content {
      height: 130px;
      display: flex;
      flex-direction: column;
      div {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;
        .label {
          display: block;
          width: 80px;
          color: #999;
        }
        .content {
          color: #000;
        }
      }
    }
    .item_time {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #000000;
      span {
        button {
          color: #ffffff;
          margin-right: 5px;
        }
        .payButton {
          width: 80px;
          padding: 5px 0;
          background-color: #f56c6c;
          border: 1px solid #f56c6c;
          border-radius: 3px;
        }
        .checkButton {
          width: 80px;
          padding: 5px 0;
          background-color: #409eff;
          border: 1px solid #409eff;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
